export default "__VITE_ASSET__ee1162a8__"